import { useEffect, useSyncExternalStore } from 'react';
import { useLocation } from 'react-router';
import {
  getAnalyticsState,
  subscribeAnalytics,
  trackPageView,
  type AnalyticsState,
} from './analytics';

/** Aktueller Zustand der Einwilligungsverwaltung (reagiert auf Annehmen, Ablehnen und Widerruf). */
export function useAnalytics(): AnalyticsState {
  return useSyncExternalStore(subscribeAnalytics, getAnalyticsState);
}

/** Meldet jeden Seitenwechsel, solange GA geladen ist (sonst ohne Wirkung). */
export function useAnalyticsPageViews(): void {
  const { pathname } = useLocation();
  const { loaded } = useAnalytics();
  useEffect(() => {
    if (loaded) trackPageView(pathname);
  }, [pathname, loaded]);
}
